import Mock from 'mockjs';

Mock.mock(/\/get\/i18n_type/, () => {
  return {
    code: 'success',
    data: {
      type: 'ZH_CN'
    },
    msg: 'ok'
  }
});



// WEBPACK FOOTER //
// ./src/mock/index.js